import axios from "axios"
import ApiHeaders from "../utils/ApiHeaders"
import MultiPartApi from "../utils/MultiPartApi"
const ApiCallServices = {
    
    create: (endPoint, data, config = {}) => {
        const headers = ApiHeaders();
        return axios.post(process.env.REACT_APP_BASE_URL+endPoint, data, { headers, ...config }).then((response) => {
            return response; 
        })
        .catch((error) => { 
            throw error; 
        });

    },
    getlisting: (endPoint) => {
        const headers = ApiHeaders();
        return axios.get(process.env.REACT_APP_BASE_URL+endPoint, {headers}).then((response) => {
            return response; 
        })
        .catch((error) => {
            throw error; 
        });
    },
    fileUpload:(endPoint, data) => {
        return axios.post(process.env.REACT_APP_BASE_URL+endPoint, data, { headers: {...MultiPartApi()} }).then((response)=> {
            return response;
        })
        .catch((error) => { 
            throw error; 
        });
    }
}

export default ApiCallServices;